'use strict';

const GooglePhone = require('google-libphonenumber');

const PhoneUtil = GooglePhone.PhoneNumberUtil.getInstance();
const PhoneFormat = GooglePhone.PhoneNumberFormat;

const internals = {};

internals.dedupe = (item, index, items) => items.indexOf(item) === index;

internals.parseValid = (number, country = 'us') => {

    const input = String(number || '').trim();

    if (!input) {
        return null;
    }

    const fallbackCountry = String(country || 'us').trim().toUpperCase();
    const digits = input.replace(/\D/g, '');
    const candidates = [
        input,
        input.startsWith('00') ? `+${digits.slice(2)}` : null,
        !input.startsWith('+') && digits ? `+${digits}` : null
    ].filter(Boolean).filter(internals.dedupe);

    for (const candidate of candidates) {
        try {
            const parsed = PhoneUtil.parse(candidate, fallbackCountry);

            if (PhoneUtil.isValidNumber(parsed)) {
                if (typeof parsed.hasExtension === 'function' && parsed.hasExtension()) {
                    parsed.clearExtension();
                }

                return parsed;
            }
        }
        catch (err) {
            // Try the next reasonable interpretation.
        }
    }

    return null;
};

internals.normalizeCountry = (country) => {

    const normalized = String(country || '').trim().toLowerCase();
    return normalized || null;
};

internals.countryMatchesCallingCode = (parsed, country) => {

    const normalizedCountry = internals.normalizeCountry(country);

    if (!normalizedCountry) {
        return true;
    }

    const expectedCallingCode = PhoneUtil.getCountryCodeForRegion(normalizedCountry.toUpperCase());
    return !expectedCallingCode || Number(parsed.getCountryCode()) === Number(expectedCallingCode);
};

const normalize = (number, country = null) => {

    const explicitCountry = internals.normalizeCountry(country);
    const parsed = internals.parseValid(number, explicitCountry || 'us');

    if (!parsed || !internals.countryMatchesCallingCode(parsed, explicitCountry)) {
        return null;
    }

    return {
        phone: PhoneUtil.format(parsed, PhoneFormat.NATIONAL).replace(/\D/g, ''),
        // The selected/passed country is authoritative. Infer only when absent.
        phoneCountry: explicitCountry || String(
            PhoneUtil.getRegionCodeForNumber(parsed) || 'us'
        ).toLowerCase()
    };
};

module.exports = {
    isValid: (number, country = null) => !!normalize(number, country),
    normalize,
    toE164: (number, country = null) => {

        const normalized = normalize(number, country);

        if (!normalized) {
            return null;
        }

        const parsed = internals.parseValid(normalized.phone, normalized.phoneCountry);
        return parsed ? PhoneUtil.format(parsed, PhoneFormat.E164) : null;
    }
};
